'use client';
import React from 'react';

export default function StickyMobileBar() {
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-[100]"
      style={{
        background: '#050510',
        borderTop: '2px solid #00f5ff',
        paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 4px)',
        boxShadow: '0 -4px 24px rgba(0,245,255,0.25), 0 -1px 0 rgba(0,245,255,0.1)',
      }}
    >
      {/* Discount reminder strip */}
      <div
        style={{
          background: 'linear-gradient(90deg, rgba(123,47,255,0.15), rgba(0,245,255,0.1), rgba(123,47,255,0.15))',
          borderBottom: '1px solid rgba(0,245,255,0.15)',
          padding: '5px 16px',
          textAlign: 'center',
        }}
      >
        <span
          style={{
            fontFamily: 'Barlow Condensed, Arial, sans-serif',
            fontWeight: 900,
            fontSize: '10px',
            textTransform: 'uppercase',
            letterSpacing: '0.12em',
            color: '#7b2fff',
            textShadow: '0 0 8px rgba(123,47,255,0.5)',
          }}
        >
          ★ Launching Sept–Oct 2026 · Join Early for 15% OFF
        </span>
      </div>

      <div className="flex items-stretch gap-0">
        {/* Primary CTA: Join Waitlist */}
        <a
          href="/waitlist"
          className="flex-1 flex items-center justify-center gap-2"
          style={{
            background: 'linear-gradient(135deg, #00f5ff 0%, #40faff 100%)',
            color: '#050510',
            fontFamily: 'Barlow Condensed, Arial, sans-serif',
            fontWeight: 900,
            fontSize: '15px',
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            minHeight: '52px',
            padding: '0 16px',
            textDecoration: 'none',
            boxShadow: '0 0 20px rgba(0,245,255,0.4)',
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          Join Waitlist
        </a>

        {/* Divider */}
        <div style={{ width: '1px', background: '#1a1a4e' }} />

        {/* Get a Quote */}
        <a
          href="/home#quote"
          className="flex flex-col items-center justify-center gap-0.5"
          style={{
            minHeight: '52px',
            minWidth: '72px',
            padding: '0 12px',
            color: '#7b2fff',
            background: 'rgba(123,47,255,0.08)',
            textDecoration: 'none',
          }}
          aria-label="Get a quote"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
          <span
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 700,
              fontSize: '8px',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
            }}
          >
            Quote
          </span>
        </a>

        {/* Divider */}
        <div style={{ width: '1px', background: '#1a1a4e' }} />

        {/* Call */}
        <a
          href="tel:+17252711448"
          className="flex flex-col items-center justify-center gap-0.5"
          style={{
            minHeight: '52px',
            minWidth: '56px',
            padding: '0 10px',
            color: '#a0b0d8',
            textDecoration: 'none',
          }}
          aria-label="Call us"
        >
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1.21h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.81a16 16 0 0 0 6.29 6.29l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
          <span
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 700,
              fontSize: '8px',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
            }}
          >
            Call
          </span>
        </a>

        {/* Divider */}
        <div style={{ width: '1px', background: '#1a1a4e' }} />

        {/* Instagram */}
        <a
          href="https://www.instagram.com/vertexpremiummobiledetailing"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-0.5"
          style={{
            minHeight: '52px',
            minWidth: '56px',
            padding: '0 10px',
            color: '#ff00ff',
            textDecoration: 'none',
          }}
          aria-label="Instagram"
        >
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="2" width="20" height="20" rx="5" />
            <circle cx="12" cy="12" r="4" />
            <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
          </svg>
          <span
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 700,
              fontSize: '8px',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
            }}
          >
            Follow
          </span>
        </a>
      </div>
    </div>
  );
}